import ProductDetails from './productDetails';

export default ProductDetails;